export const POWER_DIALER_SESSION_ROUTE_TITLE = 'Power Dialer Sessions'

// Which calls a Power Dialer session owns. The session recognises its own by the active
// task's contact and discards anything else as a late response from the task that just
// ended — a guard that predates the session ever holding a call it did not dial. An
// answered inbound call is exactly that: live, and belonging to a contact that is not the
// task, so a session paused for one is not on a task at all and its calls are not the
// session's to describe or discard.
export function isPowerDialerSessionTask (routeTitle, answeringInboundCall = false) {
  return routeTitle === POWER_DIALER_SESSION_ROUTE_TITLE && !answeringInboundCall
}

// The line a session sends SMS from. Rows saved before the SMS Line setting have no
// use_same_line_for_sms, and they keep sending from the call line.
export function getSessionSmsCampaignId (settings) {
  if (!settings) {
    return null
  }

  return settings.use_same_line_for_sms === false
    ? settings.sms_campaign_id ?? null
    : settings.campaign_id ?? null
}
